import * as Application from 'expo-application';
import { randomUUID as uuidv4 } from 'expo-crypto';
import { Platform } from 'react-native';

import { isIos } from 'utils/environment';

let deviceId: string = '';

// normal way to get deviceId except for certain circumstances
export const getDeviceId = () => deviceId;

// NOTE!!! ONLY use this function in static code that runs on app start that is already async.
// the device ID is "technically" async (thanks iOS)
// but it should be populated by the time getDeviceId is called in all react code
export const getDeviceIdAsync = async (): Promise<string> => {
  if (deviceId) {
    return deviceId;
  }

  if (Platform.OS === 'ios') {
    const iosId = await iosDeviceIdPromise;
    deviceId = iosId || '';
  } else if (Platform.OS === 'android') {
    const androidId = Application.getAndroidId();
    deviceId = androidId || '';
  } else {
    // expo removed support from this for web so keep it the same as it was in prior SDK versions
    const KEY_NAME = 'EXPO_CONSTANTS_INSTALLATION_ID';

    const id = localStorage.getItem(KEY_NAME);
    if (id) {
      deviceId = id;
    } else {
      const uuid = uuidv4();
      localStorage.setItem(KEY_NAME, uuid);
      deviceId = uuid;
    }
  }
  deviceId = deviceId.toLowerCase();
  return deviceId;
};

// get this as soon as possible and make all ios code wait for one call to it since it has been observed to take 1s to come back!
// noop outside of iOS
const iosDeviceIdPromise = isIos ? Application.getIosIdForVendorAsync() : Promise.resolve(null);
